var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8241 52.6219C51.8241 46.0872 54.1512 38.1767 58.8056 28.8905C63.2809 19.7762 70.0833 10.1461 79.213 0L85.3889 5.15901C79.3025 12.2097 75.0957 18.4865 72.7685 23.9894C70.2623 29.4923 68.9198 34.5654 68.7407 39.2085H69.5463C74.7377 39.2085 78.9444 40.7562 82.1667 43.8516C85.3889 46.947 87 51.0742 87 56.2332C87 61.2203 85.3889 65.2615 82.1667 68.3569C78.9444 71.4523 74.7377 73 69.5463 73C64.3549 73 60.1481 71.1943 56.9259 67.583C53.5247 64.1437 51.8241 59.1567 51.8241 52.6219ZM7.62939e-06 52.6219C7.62939e-06 46.0872 2.32716 38.1767 6.98148 28.8905C11.4568 19.7762 18.2593 10.1461 27.3889 0L33.5648 5.15901C27.4784 12.2097 23.2716 18.4865 20.9444 23.9894C18.4383 29.4923 17.0957 34.5654 16.9167 39.2085H17.7222C22.9136 39.2085 27.1204 40.7562 30.3426 43.8516C33.5648 46.947 35.1759 51.0742 35.1759 56.2332C35.1759 61.2203 33.5648 65.2615 30.3426 68.3569C27.1204 71.4523 22.9136 73 17.7222 73C12.5309 73 8.32407 71.1943 5.10185 67.583C1.70061 64.1437 7.62939e-06 59.1567 7.62939e-06 52.6219Z",
    fill: "url(#paint0_linear_112_13267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_13267",
    x1: 9.77657,
    y1: 556.218,
    x2: -159.803,
    y2: 538.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AB2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0078FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientQuote);
export default __webpack_public_path__ + "static/media/gradient-quote.9b70eeccf0d04675f067ddded6928ca2.svg";
export { ForwardRef as ReactComponent };